import { render } from "./ConfirmDeleteModal.vue?vue&type=template&id=6482090f&ts=true"
import script from "./ConfirmDeleteModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmDeleteModal.vue?vue&type=script&lang=ts"

import "./ConfirmDeleteModal.vue?vue&type=style&index=0&id=6482090f&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__